import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ActionSheetController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-wishlist',
  templateUrl: './wishlist.page.html',
  styleUrls: ['./wishlist.page.scss'],
})
export class WishlistPage implements OnInit {
  wishlist : any;
  Product: any;
  check : any;
  isLoading : boolean=false;
  userId: any;
  producId: any;
  deleteProduct: any;
  constructor(private toast: ToastService,
    private router: Router,
    private authService: StoreService,
     public actionSheetController: ActionSheetController,private routerActivate:ActivatedRoute,private navController : NavController) { }
  ngOnInit() {
    // this.checkk();
    // this.fetchWishlist();
    //  }

    //  ionViewDidEnter() {
    //   this.fetchWishlist();
    //   this.checkk()
       
    this.userId = localStorage.getItem('userId');
    console.log(this.userId,'useriD,')
    this.fetchWishlist()
    
    }

    //  checkk(){
    //   var check= JSON.parse(localStorage.getItem('wishlist'))
    //   if(check){
    //     if(check.length>0){
    //       this.check=true;
    //     }
    //     else{
    //       this.check=false;
    //     }
    //   }
    //   else{
    //     this.check=false;
    //   }
    // }

    //  fetchWishlist(){
    //    this.checkk();
    //   this.wishlist=JSON.parse(localStorage.getItem('wishlist')).filter(n => n)
    //   let array={
    //     array : this.wishlist
    //   }
      
    //   this.authService.wishlist(array).subscribe((res)=>{
    //     console.log(res);
    //     this.Product=res;
    //     this.isLoading=true;
    //   })
     
    // }

     productDetail(productItem: any) {
      console.log("hello hi ", productItem)
      this.router.navigate(['./product-detail/'+productItem._id])
    }

    // Wishlist(item){
    //   console.log(item._id)
    //   let wishlist = localStorage.getItem('wishlist');
    //   if(wishlist){
    //     this.wishlist = JSON.parse(wishlist);
    //     let index = this.wishlist.indexOf(item._id);
    // if(index == -1){
    //   this.wishlist.push(item._id)
    //   localStorage.setItem('wishlist',JSON.stringify(this.wishlist))
    //   // console.log(localStorage.getItem('wishlist'))
    // } else {
    //   this.wishlist.splice(index , 1)
    //   localStorage.setItem('wishlist',JSON.stringify(this.wishlist))
    // }
    // }
    //   else{
    //     console.log("item._id ",item._id)
    //     this.wishlist.push(item._id)
    //   localStorage.setItem('wishlist',JSON.stringify(this.wishlist))
    //   // console.log(localStorage.getItem('wishlist'))
    //   }
    //   this.fetchWishlist();
    // }
    shopNow(){
      this.router.navigate(['/'])
    }
    home(){
      this.router.navigate(['/'])
    }
    fetchWishlist(){
     let array={
      userId:this.userId,
     }
     
     this.authService.fetchWishlist(array).subscribe((res)=>{
       console.log(res);
       this.Product=res;
       if(res){
            if(res.length>0){
              this.check=true;
        
            }
            else{
              this.check=false;
            
            }
          }
          else{
            this.check=true;
         
          }
       console.log(this.Product,'dta,..')
       this.isLoading=true;
      
     }
     )
    
   }
   Wishlist(proId:any){
    let array={
      userId:this.userId,
      productId:proId
    }
    
    this.authService.deleteWish(array).subscribe((res)=>{
      console.log(res);
      this.deleteProduct=res;
      this.fetchWishlist()
    })
   }
  }


  
